/* tslint:disable */

declare var Object: any;
export interface SFShiftDailySF6Interface {
  "id"?: number;
}

export class SFShiftDailySF6 implements SFShiftDailySF6Interface {
  "id": number;
  constructor(data?: SFShiftDailySF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFShiftDailySF6`.
   */
  public static getModelName() {
    return "SFShiftDailySF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFShiftDailySF6 for dynamic purposes.
  **/
  public static factory(data: SFShiftDailySF6Interface): SFShiftDailySF6{
    return new SFShiftDailySF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFShiftDailySF6',
      plural: 'SFShiftDailySF6s',
      path: 'SFShiftDailySF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFShiftDailySF6.ts